import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getCourses } from "../../../helper/apicalls/course";
import { getCoursesInstitution } from "../../../helper/apicalls/institution/institutionCourse";
import GlobalLoader from "../../common/GlobalLoader";
import "./../../../styles/admin/questionBank.scss";
import openFolder from "../../../assets/png/openFolderIcon.png";
import Cookies from "js-cookie";

const MaterialsCourses = () => {
  const navigate = useNavigate();
  const { setHeaderName } = useOutletContext();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      setError(null);

      const role = Cookies.get("role");
      let data;

      if (role === "institution" || role === "teacher") {
        const res = await getCourses();
        const normalized = Array.isArray(res)
          ? res.flatMap((item) => item?.course || [])
          : [];
        setCourses(normalized);
      } else {
        data = await getCourses();
        setCourses(
          Array.isArray(data)
            ? data.map((course) => ({
                ...course,
                navigationPath: `/admin/materials/course/${course.key}`,
              }))
            : []
        );
      }
    } catch (err) {
      console.error("Error fetching courses for Materials:", err);
      setError("Failed to load courses");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCourseClick = (course) => {
    if (!course?.key) return;
    const role = Cookies.get("role");
    const portalBase =
      role === "admin"
        ? "/admin"
        : role === "teacher"
        ? "/teacher"
        : "/institution";
    navigate(`${portalBase}/materials/course/${course.key}`);
  };

  useEffect(() => {
    fetchCourses();
    setHeaderName("Materials - Courses");
  }, []);

  return (
    <div className="question-bank-container">
      <GlobalLoader visible={loading} text="Loading..." />
      <div className="qb-card">
        <div className="qb-card-header">
          <span>Materials - Courses</span>
        </div>
        <div className="folder-grid">
          {!loading &&
            !error &&
            courses?.map((course) => (
              <div
                key={course.key || course.id}
                className="folder-item"
                onClick={() => handleCourseClick(course)}
              >
                <div className="folder-icon">
                  <img
                    src={openFolder}
                    alt="openFolder"
                    style={{ width: "75px", height: "75px" }}
                  />
                </div>
                <div className="folder-name">{course.name}</div>
              </div>
            ))}
        </div>
        {error && <div className="qb-error">{error}</div>}
      </div>
    </div>
  );
};

export default MaterialsCourses;
